import React from "react";
import { Input, Checkbox, InputNumber } from "antd";
import trans from "../../../../utils";

export default function FormOptionGroupConfig({ activeItem, updateActiveItem }) {
	const config = activeItem?.groupConfig || {};

	const update = (key, value) => {
		updateActiveItem(`groupConfig.${key}`, value);
	};

	return (
		<div className="field-settings-section">
			<h5 className="field-settings-section-title">{trans("Group Configuration")}</h5>

			<div className="field-settings-control">
				<label className="form-label">{trans("Group Title")}</label>
				<Input
					value={config.groupTitle}
					onChange={(e) => update("groupTitle", e.target.value)}
					placeholder={trans("Group Title")}
				/>
			</div>

			<div className="field-settings-control">
				<label className="form-label">{trans("Item Label")}</label>
				<Input
					value={config.itemLabel}
					onChange={(e) => update("itemLabel", e.target.value)}
					placeholder={trans("Item Label")}
				/>
			</div>

			<div className="field-settings-control">
				<label className="form-label">{trans("Add Item Label")}</label>
				<Input
					value={config.addItemLabel}
					onChange={(e) => update("addItemLabel", e.target.value)}
					placeholder={trans("Add Item Label")}
				/>
			</div>

			<div className="field-settings-grid">
				<div className="field-settings-control">
					<label className="form-label">{trans("Min Items")}</label>
					<InputNumber
						min={0}
						value={config.minItems}
						onChange={(v) => update("minItems", v)}
						style={{ width: "100%" }}
					/>
				</div>
				<div className="field-settings-control">
					<label className="form-label">{trans("Max Items")}</label>
					<InputNumber
						min={1}
						value={config.maxItems}
						onChange={(v) => update("maxItems", v)}
						style={{ width: "100%" }}
					/>
				</div>
			</div>

			<div className="field-settings-switches">
				<Checkbox
					checked={config.allowDelete}
					onChange={(e) => update("allowDelete", e.target.checked)}
				>
					{trans("Allow Delete")}
				</Checkbox>
				<Checkbox
					checked={config.allowEdit}
					onChange={(e) => update("allowEdit", e.target.checked)}
				>
					{trans("Allow Edit")}
				</Checkbox>
				<Checkbox
					checked={config.collapsibleItems}
					onChange={(e) => update("collapsibleItems", e.target.checked)}
				>
					{trans("Collapsible Items")}
				</Checkbox>
				<Checkbox
					checked={config.collapseCompletedItems}
					onChange={(e) => update("collapseCompletedItems", e.target.checked)}
				>
					{trans("Collapse Completed Items")}
				</Checkbox>
			</div>
		</div>
	);
}
